"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _server = require("react-dom/server");

var _server2 = _interopRequireDefault(_server);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// extract plain text from a JSX node
var getTextFromNode = function getTextFromNode(node) {
  if (!node) return "";
  if (typeof node === "string") return node;
  if (_react2.default.isValidElement(node)) return _server2.default.renderToStaticMarkup(node).replace(/<(?:.|\n)*?>/gm, "");
  return "";
};

exports.default = getTextFromNode;